var iti;
var input = document.querySelector("#phone_tel");
var activeCountries = ["fr", "mq", "gp", "gf", "re", "yt", "bl", "mf", "pm"];

function initPhone(input) {
  iti = window.intlTelInput(input, {
    utilsScript:
      "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.3/js/utils.min.js",
    preferredCountries: activeCountries,
    initialCountry: "auto",
    separateDialCode: true,
    formatOnDisplay: true,
    autoHideDialCode: true,
    geoIpLookup: function (success, failure) {
      $.getJSON("https://ipinfo.io?token=0f4c0a56aed46f", function (resp) {
        var countryCode = resp && resp.country ? resp.country : "FR";
        var regionCode = resp && resp.region ? resp.region : "Île-de-France";
        var cityCode = resp && resp.city ? resp.city : "Paris";
        $("#country").val(countryCode + " - " + regionCode + " - " + cityCode);
        success(countryCode);
      });
    },
  });
  input.addEventListener("blur", function () {
    var number = iti.getNumber(intlTelInputUtils.numberFormat.E164);
    var error = iti.getValidationError();
    var countryData = iti.getSelectedCountryData();
    var cleanNumber = input.value.replace("+" + countryData.dialCode, "");
    input.value = cleanNumber;

    $("#email-form #phone").val(number);
  });
}

function validatePhoneNumber() {
  var countryData = iti.getSelectedCountryData();

  if (typeof getLocalInfo === "function") {
    // safe to use the function
    var currentDate = new Date();
    var currentHours = ("0" + currentDate.getHours()).substr(-2);
    var currentMinutes = ("0" + currentDate.getMinutes()).substr(-2);
    var currentTime = currentHours + ":" + currentMinutes;
    var correctTime = getLocalInfo("+" + countryData.dialCode).time.display;
    var correctTz = getLocalInfo("+" + countryData.dialCode).time.zone;

    if (currentTime != correctTime) {
      correctTz = correctTz.replace("GMT", "");
      correctTz = correctTz * -60;

      //openModalFormWithUrl('/cpfm/frontend/time-zone-error/currentTime/' + currentTime);
      //return false;
    }
  }

  if (activeCountries.indexOf(countryData.iso2) == -1) {
    openModalFormWithUrl(
      "/cpfm/frontend/phone-error/country/" + encodeURI(countryData.name)
    );
    return false;
  } else {
    return true;
  }
}

function isPhoneValid() {
  return iti.isValidNumber();
}

function InitPhoneInputs() {
  if (typeof intlTelInput == "function") {
    if (input) {
      initPhone(input);
    }
  }
}

$(document).ready(InitPhoneInputs);

export { InitPhoneInputs, isPhoneValid };
